import { productType } from "@/config";
import { Dispatch, SetStateAction } from "react";

export function upadteAndAddToCartItem(productItem: productType, setAddToCart: Dispatch<SetStateAction<productType[]>>) {
    setAddToCart(prevAddToCart => {
        const existingItemIndex = prevAddToCart.findIndex(cartItem => {
            if (cartItem._id !== productItem._id) return false;

            if (cartItem.discountPercent !== productItem.discountPercent) return false;

            const addonsMatch = cartItem.addons.every((addon, index) =>
                addon.isCheck === productItem.addons[index]?.isCheck
            );

            if (!addonsMatch) return false;

            const optionsMatch = cartItem.options.every((option, optionIdx) => {
                const cartValues = option.values;
                const productValues = productItem.options[optionIdx]?.values;

                return cartValues?.every((value, valueIdx) =>
                    value.isCheck === productValues?.[valueIdx]?.isCheck
                );
            });

            if (!optionsMatch) return false;

            if (cartItem.instruction !== productItem.instruction) return false;

            if (cartItem.status !== productItem.status) return false;

            return true;
        });

        if (existingItemIndex > -1) {
            return prevAddToCart.map((item, idx) =>
                idx === existingItemIndex
                    ? { ...item, quantity: item.quantity + productItem.quantity }
                    : item
            );
        }

        return [...prevAddToCart, { ...productItem }];
    });
}

export function updateAddToCart(updatedItem: productType, setAddToCart: Dispatch<SetStateAction<productType[]>>) {
    setAddToCart(prevAddToCart => {

        if (updatedItem.quantity === 0) {
            return prevAddToCart.filter(item => item._id !== updatedItem._id);
        }

        const existingItem = prevAddToCart.find(item => item._id === updatedItem._id);

        if (existingItem) {
            return prevAddToCart.map(item => {
                const itemDiscount = item.discountPercent ?? 0;
                const updatedDiscount = updatedItem.discountPercent ?? 0;

                return item._id === updatedItem._id && itemDiscount === updatedDiscount
                    ? { ...item, ...updatedItem, quantity: updatedItem.quantity }
                    : item;
            });
        }

        return [
            ...prevAddToCart,
            {
                ...updatedItem,
                isCheck: true
            }
        ];
    });
}

// export function updateAddToCart(updatedItem: productType, setAddToCart: Dispatch<SetStateAction<productType[]>>) {
//     setAddToCart(prevAddToCart => {
//         const existingItem = prevAddToCart.find(
//             item => item._id === updatedItem._id && item.discountPercent === updatedItem.discountPercent
//         );

//         if (updatedItem.quantity === 0) {
//             return prevAddToCart.filter(
//                 item => !(item._id === updatedItem._id && item.discountPercent === updatedItem.discountPercent)
//             );
//         }

//         if (existingItem) {
//             return prevAddToCart.map(item =>
//                 item._id === updatedItem._id && item.discountPercent === updatedItem.discountPercent
//                     ? { ...item, quantity: updatedItem.quantity }
//                     : item
//             );
//         }

//         return [
//             ...prevAddToCart,
//             {
//                 ...updatedItem,
//                 isCheck: true
//             }
//         ];
//     });
// }